// The task rules My Tasks follows, in one pure place.
//
// ⚠️ THE COACH APP'S TASKS SCREEN FOLLOWS THE SAME RULES (2026-10-06), from its
// own copy in apps/mobile/lib/tasks-rules.ts, because the app cannot load this
// file. apps/mobile/lib/__tests__/tasks-match-the-crm.test.ts runs both copies
// on the same tasks and fails the moment they disagree, so a change here has
// to be made there too.
//
// Moved out of coach-tasks.js unchanged (_dueTag, _subStatusPatch and the
// sub-list rule inside toggleDone). Pure: no clock, no DOM, no network.

/**
 * The small due-date label on a task row: "Today", "3d overdue", a weekday
 * within six days, else "Oct 13". Null when the task has no due date.
 * @param {string|null|undefined} due YYYY-MM-DD
 * @param {string} today YYYY-MM-DD in the coach's time zone
 * @returns {{ text: string, cls: ''|'today'|'over' } | null}
 */
export function dueTag(due, today) {
  if (!due) return null;
  const t = today;
  if (due === t) return { text: 'Today', cls: 'today' };
  if (due < t) return { text: Math.round((new Date(t) - new Date(due)) / 86400000) + 'd overdue', cls: 'over' };
  const dt = new Date(due + 'T12:00:00');
  const days = Math.round((dt - new Date(t + 'T12:00:00')) / 86400000);
  return { text: days <= 6 ? dt.toLocaleDateString('en-US', { weekday: 'short' }) : dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }), cls: '' };
}

/**
 * One rule, both directions: all subs done → the parent completes itself;
 * a sub gets unchecked on a completed parent → the parent reopens.
 * @param {{ status: string }} task
 * @param {{ done: boolean }[]} subs the sub-list as it is about to be saved
 * @returns {{ status?: 'done'|'todo' }}
 */
export function subStatusPatch(task, subs) {
  const allDone = subs.length > 0 && subs.every(s => s.done);
  if (allDone && task.status !== 'done') return { status: 'done' };
  if (!allDone && task.status === 'done') return { status: 'todo' };
  return {};
}

/**
 * Completing the parent completes its sub-list too ("the task is done" means
 * all of it). Reopening leaves the subs as they are: the coach unchecks
 * exactly what still needs doing. Returns the SAME array when nothing changes,
 * so a caller can tell whether the subs need saving.
 * @template {{ done: boolean }} S
 * @param {S[]} prevSubs
 * @param {'done'|'todo'} nextStatus
 * @returns {S[]}
 */
export function subsOnStatusChange(prevSubs, nextStatus) {
  return nextStatus === 'done' && prevSubs.some(s => !s.done)
    ? prevSubs.map(s => ({ ...s, done: true }))
    : prevSubs;
}
